import axios, { AxiosResponse } from 'axios'

import { API_CONFIG, getEnv } from '../config/api'
import { Configuration } from '../redux/configuration'

const env = getEnv()

const {
  configurations: { url: configurationsUrl, token },
} = API_CONFIG[env]

const getConfiguration = async (commerceName: string): Promise<AxiosResponse<Configuration>> => {
  const url = `${configurationsUrl}${commerceName}`

  const response = await axios.get(url, {
    headers: { Authorization: token },
  })

  return response
}

export default getConfiguration
